import { render, staticRenderFns } from "./ShopRouter.vue?vue&type=template&id=84a5eda4&scoped=true"
import script from "./ShopRouter.vue?vue&type=script&lang=js"
export * from "./ShopRouter.vue?vue&type=script&lang=js"
import style0 from "./ShopRouter.vue?vue&type=style&index=0&id=84a5eda4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a5eda4",
  null
  
)

export default component.exports